import { Link } from 'react-router-dom';
import { NAV_ITEMS, SITE_EMAIL, SITE_NAME, SITE_TAGLINE } from '@/mocks/site';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950 font-heading text-lg font-bold">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{SITE_NAME}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">{SITE_TAGLINE}。从海选到决赛，截稿、开投、出结果三类节点一条线看完。</p>
            <p className="mt-5 text-sm text-background-300">
              联系邮箱：<a href={`mailto:${SITE_EMAIL}`} className="text-accent-300 hover:text-accent-200">{SITE_EMAIL}</a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors">网站导航</Link>
            </h4>
            <ul className="space-y-2 text-sm">
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-background-200 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <Link to="/schedule" className="hover:text-accent-300 transition-colors">赛程速查</Link>
            </h4>
            <ul className="space-y-2 text-sm text-background-200">
              <li>海选截稿：9 月 20 日</li>
              <li>初赛公投：9 月 26 日 – 10 月 10 日</li>
              <li>决赛投票截止：11 月 20 日</li>
              <li>颁奖盛典：11 月 30 日</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2026 {SITE_NAME} · 本站内容仅用于赛事信息展示</p>
          <p>所有时间以北京时间（UTC+8）为准</p>
        </div>
      </div>
    </footer>
  );
}